/**
 * View configuration for the Devices Management module
 */

export const DEVICES_MANAGEMENT_VIEWS_STRUCTURE = [
  {
    category: "Projects",
    icon: "Folder",
    subViews: [
      {
        id: "my-projects",
        name: "My Projects",
        description: "Projects I own",
        whoCanAccess: ["ADMIN", "MANAGER"],
      },
    ],
  },
  {
    category: "Points",
    icon: "MapPin",
    subViews: [
      {
        id: "all-points",
        name: "All Points",
        description: "All system points",
        whoCanAccess: ["ADMIN", "MANAGER"],
      },
    ],
  },
  {
    category: "Sites",
    icon: "Home",
    subViews: [
      {
        id: "all-sites",
        name: "All Sites",
        description: "All system sites",
        whoCanAccess: ["ADMIN", "MANAGER"],
      },
    ],
  },
  {
    category: "Device Types",
    icon: "Layers",
    subViews: [
      {
        id: "all-device-types",
        name: "All Device Types",
        description: "All device type definitions",
        whoCanAccess: ["ADMIN"],
      },
    ],
  },
  {
    category: "Room Types",
    icon: "Grid",
    subViews: [
      {
        id: "all-room-types",
        name: "All Room Types",
        description: "All room type definitions",
        whoCanAccess: ["ADMIN"],
      },
    ],
  },
  {
    category: "Point Types",
    icon: "Tag",
    subViews: [
      {
        id: "all-point-types",
        name: "All Point Types",
        description: "All point type definitions",
        whoCanAccess: ["ADMIN"],
      },
    ],
  },
];
